// import { Flow } from 'signup-constants/Flow';
// import { Integration } from 'signup-constants/Integration';
// import { FlowOrIntegration } from 'signup-constants/types';
// import { getIntegrationOrFlowKey } from 'signup-ui-lego-core/routing/getIntegrationOrFlowKey';
import { isQA } from '../constants/apiEnvironments'; // const Batch1 = [
//   Flow.Integrations,
//   Flow.ClassroomTraining,
//   Integration.Wpforms,
//   Flow.FbCrm,
//   Flow.AssetProvider,
//   Flow.SolutionsProvider,
//   Flow.Connect,
// ];
// const Batch2: FlowOrIntegration[] = [
//   Flow.HubSpotPartners,
//   Flow.HubspotForNonprofits,
//   Flow.Purchase,
// ];
// const Batch3: FlowOrIntegration[] = [
//   Flow.DirectoryListing,
//   Flow.CmsDevelopers,
//   Flow.HubspotForStartups,
//   Flow.Service,
// ];
// const Batch4 = [
//   Flow.Developers,
//   Flow.CmsFree,
//   Integration.Wordpress,
//   Flow.Sales,
//   Flow.Marketing,
// ];
// const Batch5: FlowOrIntegration[] = [Flow.Academy, Flow.Crm, Flow.Trial];

export const shouldUseBEToSubmitAmplitudeEvent = () => {
  // const flowKey = getIntegrationOrFlowKey();
  return isQA; // Batch1.includes(flowKey) ||
  // Batch2.includes(flowKey) ||
  // Batch3.includes(flowKey) ||
  // Batch4.includes(flowKey) ||
  // Batch5.includes(flowKey)
};